<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">RIONet News</h1>
                </div>
            </div>
            <div class="row"
                 v-if="currentUser && (currentUser.roles.indexOf('client_admin') !== -1 || currentUser.roles.indexOf('user_admin') !== -1)">
                <div class="col-xl-3">
                    <stats-card icon="fad fa-comment-sms"
                                class="mb-4 mb-xl-0">
                        <h2>SMS Alarmierung</h2>
                        <button class="btn btn-m btn-success" title="Nummern verwalten" @click="showNumbers = true">
                            Nummern verwalten
                        </button>
                        <template v-slot:footer>
                            <!--            <span class="text-danger mr-2">{{ overdueIncidents }}</span>
                                        <span class="text-nowrap">{{ overdue }}</span>-->
                        </template>
                    </stats-card>
                </div>
                <modal v-model:show="showNumbers" @close="showNewNumber = false; errorNumber = ''"
                       modal-classes="modal-sm" bodyClasses="mt--4">
                    <template v-slot:header>
                        <h5 class="modal-title" id="modal-title-notification">Liste für SMS Alarmierung</h5>
                    </template>
                    <ul class="list-group">
                        <li v-for="number in rioNumbers"
                            class="list-group-item d-flex justify-content-between align-items-center">
                            {{ number.number }}
                            <div>
                                <button class="btn btn-sm btn-danger" @click.stop.prevent="deleteRioNumber(number.id)"
                                        title="Nummer entfernen">
                                    <i class="fad fa-trash"></i>
                                </button>
                            </div>
                        </li>
                        <li v-if="showNewNumber" class="list-group-item">
                            <div class="input-group">
                                <input type="text" class="form-control" @keyup.enter="createRioNumber"
                                       v-bind:autofocus="showNewNumber" v-model="newNumber">
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-success input-group-text" title="Nummer speichern"
                                            @click.stop.prevent="createRioNumber">
                                        <i class="fad fa-circle-check"></i>
                                    </button>
                                </div>
                            </div>
                            <small class="errorText" v-if="errorNumber.length > 0">{{
                                    errorNumber
                                }}</small>
                        </li>
                    </ul>
                    <button v-if="!showNewNumber" @click.stop.prevent="showNewNumber = true;"
                            class="mt-3 btn btn-block btn-success">Neue Nummer erfassen
                    </button>
                </modal>
            </div>
        </base-header>
        <div class="container-fluid"
             :class="(currentUser && (currentUser.roles.indexOf('client_admin') !== -1 || currentUser.roles.indexOf('user_admin') !== -1)) ? 'mt--6' : 'mt--7'">
            <div class="card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col-10">
                            <base-button class="mt-1 mb-1" size="lg" @click="filter = 0" :type="(filter === 0) ? 'primary' : 'secondary'">
                                Alle
                                Kategorien
                            </base-button>
                            <base-button class="mt-1 mb-1" v-for="category in categories" @click="filter = category.id" size="lg"
                                         :type="(category.id === filter) ? 'primary' : 'secondary'">{{ category.title }}
                            </base-button>
                            <base-button class="mt-1 mb-1" size="lg" @click="filter = -1"
                                         :type="(filter === -1) ? 'primary' : 'secondary'">
                                Archiv
                            </base-button>
                        </div>
                        <div class="col text-right">
                            <button v-if="currentUser.roles.indexOf('user_admin') !== -1" class="btn btn-m btn-success"
                                    title="News Beitrag erstellen" @click.prevent="showModal = true;">
                                <i class="fad fa-plus-circle"></i><span>News Beitrag erstellen</span>
                            </button>
                            <modal v-model:show="showModal" modal-classes="modal-xl">
                                <template v-slot:header>
                                    <h4 class="modal-title" id="exampleModalLabel">Neuen News Beitrag
                                        erstellen</h4>
                                </template>
                                <div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <input class="form-control" name="title" type="text" placeholder="Titel"
                                                       v-model="newsTitle">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <el-select
                                                id="category"
                                                v-model="newsCategories"
                                                class="btn-block"
                                                no-match-text="Kein Eintrag"
                                                default-first-option
                                                filterable multiple
                                                placeholder="Kategorie auswählen">
                                                <el-option
                                                    v-for="(category, index) in categories"
                                                    :key="index"
                                                    class="select-primary"
                                                    :value="category.id"
                                                    :label="category.title">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <base-input name="textarea">
                                                <textarea
                                                    v-model="newsTeaser"
                                                    class="form-control textarea-autosize"
                                                    placeholder="Teaser">
                                                </textarea>
                                                <i class="form-group--bar"></i>
                                            </base-input>
                                        </div>
                                    </div>
                                    <ckeditor class="form-control" v-model="newsContent" :editor="editor"
                                              :config="editorConfig" :rows="12" required></ckeditor>
                                    <small class="errorText" v-if="errorText.length > 0">{{
                                            errorText
                                        }}</small>
                                </div>
                                <template v-slot:footer>
                                    <base-button :disabled="disabled" @click.prevent="clearForm"
                                                 title="Eingaben löschen"
                                                 type="secondary">
                                        Eingaben löschen
                                    </base-button>
                                    <base-button :disabled="disabled" title="Erstellen" @click.prevent="createNewsEntry"
                                                 type="success">
                                        Erstellen
                                    </base-button>
                                </template>
                            </modal>
                        </div>
                    </div>
                </div>
                <modal v-model:show="showEntry" modal-classes="modal-l">
                    <template v-slot:header>
                        <div class="w-100">
                            <badge class="mr-2"
                                   v-for="category in newSingleEntry.rio_news_categories" rounded
                                   type="primary">{{ category.title }}
                            </badge>
                        </div>
                    </template>
                    <small>{{ convertDate(newSingleEntry.dateFrom) }}</small>
                    <h2 class="display-3">{{ newSingleEntry.title }}</h2>
                    <div class="display-4">
                        <span>{{ newSingleEntry.teaser }}</span>
                    </div>
                    <br>
                    <div class="newsContent">
                        <span v-html="newSingleEntry.content"></span>
                    </div>
                </modal>
                <div class="card-body p-0">
                    <div class="list-group list-group-flush">
                        <a href="#" v-for="newsEntry in filteredNews" @click.prevent="openNewsEntry(newsEntry)"
                           class="list-group-item list-group-item-action flex-column align-items-start py-4 px-4">
                            <div class="d-flex w-100 justify-content-between">
                                <div>
                                    <div class="d-flex w-100 align-items-center">
                                        <badge class="mr-2"
                                               v-for="category in newsEntry.rio_news_categories" rounded
                                               type="primary">{{ category.title }}
                                        </badge>
                                    </div>
                                </div>
                                <small>{{ convertDate(newsEntry.dateFrom) }}</small>
                            </div>
                            <h3 class="mt-3 mb-1">{{ newsEntry.title }}</h3>
                            <p class="mb-0">{{ newsEntry.teaser }}</p>
                            <div class="float-right" v-if="currentUser.roles.indexOf('user_admin') !== -1">
                                <button class="btn btn-sm btn-warning" v-if="!newsEntry.dateTo"
                                        title="News Beitrag archivieren"
                                        @click.stop.prevent="archiveNewsEntry(newsEntry.id)">
                                    <i class="fad fa-boxes-packing"></i>
                                </button>
                                <button class="btn btn-sm btn-danger"
                                        title="News Beitrag entfernen"
                                        @click.stop.prevent="deleteNewsEntry(newsEntry.id)">
                                    <i class="fad fa-trash"></i>
                                </button>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref, watch, computed, onMounted} from 'vue';
import swal from 'sweetalert2';
import UserService from '@/services/user.service';
import moment from 'moment';
import Modal from "@/components/Modal";
import {useStore} from 'vuex';
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import UnderlinePlugin from "@ckeditor/ckeditor5-basic-styles/src/underline";
import HeadingPlugin from "@ckeditor/ckeditor5-heading/src/heading";
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import SubscriptPlugin from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import SuperscriptPlugin from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Font from '@ckeditor/ckeditor5-font/src/font';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
import ListProperties from '@ckeditor/ckeditor5-list/src/listproperties';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import StatsCard from "../../../components/Cards/StatsCard";

export default {
    name: "RIONews",
    components: {
        StatsCard,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        Modal,
    },
    props: {
        type: {
            type: String,
            default: ""
        }
    },
    setup() {
        const store = useStore();
        const currentUser = computed(() => store.state.auth.user);

        const hoverSMS = ref(false);
        const showNumbers = ref(false);
        const showNewNumber = ref(false);
        const newNumber = ref('');

        const rioNumbers = ref([]);

        const getRioNumbers = () => {
            UserService.getRioNumbers().then(
                response => {
                    rioNumbers.value = response.data.data;
                },
                error => {
                    getError(error);
                }
            );
        }

        const swissPhoneRegexp = [/((\+|00)\d{8,30})/, /(0[1-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2})/, /(0[0-9]{9,11})/];

        const errorNumber = ref('');
        const createRioNumber = () => {
            if (newNumber.value.length < 1) {
                errorNumber.value = "Bitte geben Sie eine Nummer ein!";
                return false;
            }
            if (swissPhoneRegexp.some(item => item.test(newNumber.value))) {
                UserService.createRioNumber(newNumber.value).then(
                    () => {
                        getRioNumbers();
                        newNumber.value = '';
                        errorNumber.value = '';
                        showNewNumber.value = false;
                    },
                    error => {
                        getError(error);
                    }
                );
            } else {
                errorNumber.value = "Bitte geben Sie eine gültige Nummer ein!";
                return false;
            }
        }

        const deleteRioNumber = (id) => {
            UserService.deleteRioNumber(id).then(
                () => {
                    getRioNumbers();
                },
                error => {
                    getError(error);
                }
            );
        }


        const newSingleEntry = ref({});

        const filter = ref(0);
        const news = ref([]);
        const categories = ref([]);
        const getCategories = () => {
            UserService.getRioNetCategories().then(
                response => {
                    categories.value = response.data.data;
                },
                error => {
                    getError(error);
                }
            );
        }

        const getNews = () => {
            UserService.getRioNetNews().then(
                response => {
                    news.value = response.data.data;
                },
                error => {
                    getError(error);
                }
            );
        }

        const getArchive = () => {
            UserService.getRioNetArchive().then(
                response => {
                    news.value = response.data.data;
                },
                error => {
                    getError(error);
                }
            );
        }

        const convertDate = (date) => {
            return moment(date).format('DD.MM.YYYY');
        }

        const filteredNews = computed(() => {
            const entries = news.value.sort((a, b) => {
                if (a.dateFrom < b.dateFrom) return 1
                if (a.dateFrom > b.dateFrom) return -1
                return 0;
            });
            if (filter.value === 0 || filter.value === -1) {
                return entries;
            } else {
                return entries.filter(item => item.rio_news_categories.some(cat => cat.id === filter.value));
            }
        });

        const disabled = ref(false);
        const showModal = ref(false);
        const showEntry = ref(false);
        const newsCategories = ref([]);
        const newsContent = ref('');
        const newsTitle = ref('');
        const newsTeaser = ref('');
        const errorText = ref('');

        function getError(error) {
            if (error.response && error.response.status === 401) {
                errorText.value = 'you are not logged in!';
            } else if (error.response && error.response.status === 403) {
                errorText.value = 'you are not permitted!';
            } else {
                errorText.value =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        }

        const clearForm = () => {
            newsCategories.value = [];
            newsContent.value = '';
            newsTitle.value = '';
            newsTeaser.value = '';
        }

        const openNewsEntry = (item) => {
            newSingleEntry.value = item;
            showEntry.value = true;
        }

        const createNewsEntry = () => {
            //todo validate form
            disabled.value = true;
            const newsEntry = {
                'title': newsTitle.value,
                'teaser': newsTeaser.value,
                'content': newsContent.value,
            };
            UserService.createNewsEntry(newsEntry, newsCategories.value).then(
                () => {
                    swal.fire({
                        icon: 'success',
                        title: 'Beitrag erfolgreich erstellt',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    getNews();
                    clearForm();
                    errorText.value = '';
                    disabled.value = false;
                    showModal.value = false;
                },
                error => {
                    disabled.value = false;
                    getError(error);
                }
            );
        }

        const deleteNewsEntry = (id) => {
            swal.fire({
                icon: 'warning',
                title: `Den News Beitrag wirklich löschen?`,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-danger btn-fill',
                    cancelButton: 'btn btn-secondary btn-fill'
                },
                showCancelButton: true,
                cancelButtonText: 'Schliessen',
                confirmButtonText: 'Löschen',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    UserService.deleteNewsEntry(id)
                        .then(
                            response => {
                                if (!response) {
                                    throw new Error(response.statusText)
                                }
                                errorText.value = '';
                                if (filter.value === -1) {
                                    getArchive();
                                } else {
                                    getNews();
                                }
                                return response.message
                            },
                            error => {
                                getError(error);
                            }
                        ).catch(error => {
                        swal.showValidationMessage(
                            `Request failed: ${error}`
                        )
                    })
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        icon: 'success',
                        title: 'News Beitrag wurde gelöscht!',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            })
        }

        const archiveNewsEntry = (id) => {
            swal.fire({
                icon: 'warning',
                title: `Den News Beitrag wirklich archivieren?`,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-warning btn-fill',
                    cancelButton: 'btn btn-secondary btn-fill'
                },
                showCancelButton: true,
                cancelButtonText: 'Schliessen',
                confirmButtonText: 'Archivieren',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    UserService.archiveNewsEntry(id)
                        .then(
                            response => {
                                if (!response) {
                                    throw new Error(response.statusText)
                                }
                                errorText.value = '';
                                getNews();
                                return response.message
                            },
                            error => {
                                getError(error);
                            }
                        ).catch(error => {
                        swal.showValidationMessage(
                            `Request failed: ${error}`
                        )
                    })
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        icon: 'success',
                        title: 'News Beitrag wurde archiviert!',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            })
        }

        watch(filter, (newValue, oldValue) => {
            if (oldValue !== -1 && newValue === -1) {
                getArchive();
            }
            if (oldValue === -1 && newValue !== -1) {
                getNews();
            }
        });

        onMounted(() => {
            getCategories();
            getNews();
            if (currentUser.value.roles.indexOf('client_admin') !== -1 || currentUser.value.roles.indexOf('user_admin') !== -1) {
                getRioNumbers();
            }
        });

        return {
            disabled,
            errorText,
            newSingleEntry,
            getCategories,
            createNewsEntry,
            openNewsEntry,
            archiveNewsEntry,
            deleteNewsEntry,
            clearForm,
            showModal,
            errorNumber,
            showEntry,
            showNumbers,
            showNewNumber,
            createRioNumber,
            deleteRioNumber,
            rioNumbers,
            newNumber,
            filteredNews,
            categories,
            news,
            hoverSMS,
            filter,
            convertDate,
            currentUser,
            newsCategories,
            newsTitle,
            newsTeaser,
            newsContent,
            editor: ClassicEditor,
            editorConfig: {
                language: 'de',
                plugins: [
                    EssentialsPlugin,
                    BoldPlugin,
                    ItalicPlugin,
                    UnderlinePlugin,
                    SubscriptPlugin,
                    SuperscriptPlugin,
                    HeadingPlugin,
                    Alignment,
                    LinkPlugin,
                    ParagraphPlugin,
                    Image,
                    ImageUpload,
                    Font,
                    FontFamily,
                    ListProperties,
                    Table,
                    TableToolbar,
                    TableProperties,
                    TableCellProperties,
                ],
                image: {
                    upload: {
                        types: ['png', 'jpeg', 'bmp', 'gif']
                    }
                },
                extraPlugins: [Base64UploadAdapter],
                toolbar: {
                    items: [
                        'heading', '|',
                        'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
                        'alignment', '|',
                        'bold', 'italic', 'underline', 'subscript', 'superscript', '|',
                        'link', 'imageUpload', '|',
                        'numberedList', 'bulletedList', '|',
                        'insertTable', '|',
                        'undo', 'redo',
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells',
                        'tableProperties', 'tableCellProperties'
                    ],
                }
            },
        };
    },
};
</script>
<style scoped lang="scss">

.newsTeaser span {
    font-size: 1.4em;
    font-weight: 600;
}

.newsContent span {
    font-size: 1.2em;
}
</style>
